import { createContext } from 'react'

import { createPriceCompareListStore } from '../store/createStore'

export const PriceCompareListStoreContext = createContext<
  ReturnType<typeof createPriceCompareListStore> | undefined
>(undefined)
